import { IconNameEnum } from "@b2bportal/core-themes";
import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Pill, PillTone, Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./HomeFeatures.module.scss";

export const HomeFeatures = ({
  maxOccupancy,
  numberOfBedrooms,
  numberOfBathrooms,
  className,
}: {
  maxOccupancy: number;
  numberOfBedrooms: number;
  numberOfBathrooms: number;
} & PlatformComponentProps) => {
  const [block, cn] = useModuleBEM(styles, "HomeFeatures");

  const { t } = useI18nContext();
  return (
    <div className={clsx(block, className)}>
      <Pill
        className={cn("pill")}
        icon={<Icon iconName={IconNameEnum.guest} />}
        tone={PillTone.custom}
      >
        {t("core-hotels.homes.maxOccupancy", {
          count: maxOccupancy,
        })}
      </Pill>
      <Pill
        className={cn("pill")}
        icon={<Icon iconName={IconNameEnum.bed} />}
        tone={PillTone.custom}
      >
        {t("core-hotels.homes.bedroom", {
          count: numberOfBedrooms,
        })}
      </Pill>
      <Pill
        className={cn("pill")}
        icon={<Icon iconName={IconNameEnum.stays__bathroom} />}
        tone={PillTone.custom}
      >
        {t("core-hotels.homes.bathroom", {
          count: numberOfBathrooms,
        })}
      </Pill>
    </div>
  );
};
